import { fromDaysToBiggestAsPossible } from '@/utils/dateTime';

// The API expresses "never expires" as a ~100-year retention horizon rather than a dedicated
// field: retention stays a plain day count, and this value is far beyond any snapshot lifetime.
export const UNLIMITED_RETENTION_DAYS = 36500;

// The sentinel is also a legal finite retention (100 years) for policy types that
// allow it, so callers opt in where unlimited is actually offered.
export const isUnlimitedRetention = (retentionInDays?: number) =>
  retentionInDays === UNLIMITED_RETENTION_DAYS;

export const UNLIMITED_RETENTION_TEXT = 'unlimited time';

export const getHumanizeRetentionText = (retentionInDays: number) => {
  const formattedRetention = fromDaysToBiggestAsPossible(retentionInDays);
  const retentionText =
    formattedRetention.value === 1
      ? `a ${formattedRetention.unit.slice(0, -1)}`
      : `${formattedRetention.value} ${formattedRetention.unit}`;
  return retentionText;
};
